import React from 'react';
// Images
import OnlineImage from '../../assets/images/smallGallery/miss-dominatrixa-elite-dominatrix-with-adult-baby.webp';
import RealTimeImage from '../../assets/images/main/miss-dominatrixa-pro-domme-spanking-sub.webp';
import RatesImage from '../../assets/images/main/miss-dominatrixa-dungeon-image-punishment-of-masked-slave.webp';
// Constants
import {
  DUNGEON_SESSIONS_URL,
  ONLINE_SESSIONS_URL,
  RATES_AND_TRIBUTES_URL,
} from '../../utils/Routes';

const items = [
  {
    id: 1,
    title: 'Online Sessions',
    subtitle: 'View more of me in various poses.',
    image: OnlineImage,
    link: ONLINE_SESSIONS_URL,
  },
  {
    id: 2,
    title: 'My Dungeon',
    subtitle: 'Fill in to Fulfill Fantasies.',
    image: RealTimeImage,
    link: DUNGEON_SESSIONS_URL,
  },
  {
    id: 3,
    title: 'Rates & Services',
    subtitle: 'Fill in to Fulfill Fantasies.',
    image: RatesImage,
    link: RATES_AND_TRIBUTES_URL,
  },
];

function PlaySectionTwo() {
  return (
    <section className='lg:container mx-auto px-6 sm:px-10 md:px-20 mt-2 lg:mt-0 lg:px-12'>
      {/* Title */}
      <section className='grid grid-cols-reg w-full gap-x-6 mb-4'>
        {/* Large screen */}
        <div className='hidden md:grid items-center'>
          <h4 className='text-3xl neon_text_thin font-titleFont tracking-widest'>
            Explore More of Me
          </h4>
        </div>
        {/* Phone screen */}
        <div className='grid md:hidden items-center'>
          <h4 className='text-2xl neon_text_thin font-titleFont tracking-widest'>
            Explore <br /> More of Me
          </h4>
        </div>
        <div className='grid items-center'>
          <div
            className='h-[2px] -mb-1 bg-colour4'
            role='separator'
            aria-hidden='true'
          ></div>
        </div>
      </section>

      {/* Main */}
      <section className='grid lg:grid-cols-3 gap-8 lg:gap-8'>
        {items.map((item) => (
          <a
            href={item.link}
            key={item.id}
            className='border-b-2 grid grid-rows-rev pb-4 border-solid border-colour4'
          >
            <img
              src={item.image}
              alt={item.title}
              className='w-full h-full object-cover max-h-[70vh] lg:max-h-[50vh] shadow-cardShadow shadow-colour4 rounded-md'
              loading='lazy'
            />
            <div className='h-fit'>
              <h5 className='text-colour3 dark:text-colour3 text-xl font-titleFont mt-3 lg:mt-4 font-semibold'>
                {item.title}
              </h5>
              <p className='play-subtitle'>{item.subtitle}</p>
            </div>
          </a>
        ))}
      </section>
    </section>
  );
}

export default PlaySectionTwo;
